import { render, staticRenderFns } from "./NominationListComponent.vue?vue&type=template&id=33359e69&scoped=true"
import script from "./NominationListComponent.vue?vue&type=script&lang=js"
export * from "./NominationListComponent.vue?vue&type=script&lang=js"
import style0 from "./NominationListComponent.vue?vue&type=style&index=0&id=33359e69&prod&scoped=true&lang=css"
import style1 from "./NominationListComponent.vue?vue&type=style&index=1&id=33359e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33359e69",
  null
  
)

export default component.exports